import { useDispatch, useSelector } from "react-redux";
import { updateConfig } from "../../../store/slices/Report/cardOfferSlice";
import { updateConfig as globalUpdateConfig } from "../../../store/slices/Global";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getCardOfferExportedData } from "../api";
import { getFormatedDate } from "../../../utils/Functions/table";
import {
  useGetCardOfferListDataQuery,
  useGetCardOfferBasicListDataQuery,
  useUpdateCardOfferTableHeadDataMutation,
} from "../../../store/queries/Report";

const useCardOffer = () => {
  let paginationOptions = [
    { label: "10 Per page", value: 10 },
    { label: "20 Per page", value: 20 },
    { label: "30 Per page", value: 30 },
  ];
  const dispatch = useDispatch();
  const [isExcelLinkSend, setIsExcelLinkSend] = useState(false);
  const { tableFields, showEditModal } = useSelector((state) => state.global);
  const cardOfferState = useSelector((state) => state.cardOffer);
  const { data: basicData = {} } = useGetCardOfferBasicListDataQuery();

  const {
    data: userFeedbackList = {},
    isLoading,
    isFetching,
    refetch,
  } = useGetCardOfferListDataQuery({
    page_size: cardOfferState?.currentPageSize,
    page: cardOfferState?.currentPage,
    search: cardOfferState?.search,
    start_date: getFormatedDate(cardOfferState?.startDate),
    end_date: getFormatedDate(cardOfferState?.endDate),
    customer_key: cardOfferState?.storeId,
    offer_id: cardOfferState?.offerId,
  });

  const [updateUserFeedbackFields] = useUpdateCardOfferTableHeadDataMutation();
  const handleSearch = (e) => {
    dispatch(
      updateConfig((state) => {
        state.search = e?.target?.value;
        state.currentPage = 1;
      })
    );
  };
  useEffect(() => {
    if (userFeedbackList && userFeedbackList?.data?.total_count) {
      dispatch(
        updateConfig((state) => {
          state.totalCount = userFeedbackList?.data?.total_count ?? "0";
        })
      );
    }
    //eslint-disable-next-line
  }, [userFeedbackList?.data?.total_count]);
  const [date, setDate] = useState({
    startDate: cardOfferState.startDate,
    endDate: cardOfferState.endDate,
    key: "selection",
  });

  const handleClearClick = () => {
    dispatch(updateConfig((state) => (state.search = "")));
  };

  const handleSort = (label) => {
    if (cardOfferState?.sortBy === label) {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortOrder =
            cardOfferState?.sortOrder === "asc" ? "desc" : "asc";
        })
      );
    } else {
      dispatch(
        updateConfig((state) => {
          state.currentPage = 1;
          state.sortBy = label;
          state.sortOrder = "asc";
        })
      );
    }
  };

  const handleEditColumnsClick = () => {
    dispatch(
      globalUpdateConfig((state) => {
        state.showEditModal = !state.showEditModal;
      })
    );
  };

  const getRow = (field, data) => {
    const rows = {
      common: (field, data) => <p className="pro-mb-0">{data[field]}</p>,
    };
    return rows?.[field]?.(field, data) ?? rows["common"](field, data);
  };

  const handlePagination = (page) => {
    dispatch(
      updateConfig((state) => {
        state.currentPage = page;
      })
    );
  };

  const handlePageSize = ({ value: page_size }) => {
    dispatch(
      updateConfig((state) => {
        state.currentPageSize = page_size;
        state.currentPage = 1;
      })
    );
  };
  const handleUserFeedbackExcelDownload = () => {
    dispatch(
      updateConfig((state) => {
        state.CardOfferExcelSendModal = !state.CardOfferExcelSendModal;
      })
    );
  };
  const modalClose = () => {
    dispatch(
      updateConfig((state) => {
        state.CardOfferExcelSendModal = false;
      })
    );
  };
  const handleDateChange = (range) => {
    setDate(range);
    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = range.startDate;
        state.endDate = range.endDate;
      })
    );
  };
  const handleDateRangeChange = (range) => {
    const startDate = range[0];
    const endDate = range[1];

    setDate({
      startDate,
      endDate,
    });

    dispatch(
      updateConfig((state) => {
        state.currentPage = 1;
        state.startDate = startDate;
        state.endDate = endDate;
      })
    );
  };
  const sendExcelData = async (value) => {
    setIsExcelLinkSend(true);
    let params = {
      email: value?.email ?? "",
      start_date: getFormatedDate(cardOfferState.startDate ?? ""),
      end_date: getFormatedDate(cardOfferState.endDate ?? ""),
      search: cardOfferState?.search,
      customer_key: cardOfferState?.storeId,
      offer_id: cardOfferState?.offerId,
    };
    let response = await getCardOfferExportedData(params);
    try {
      if (response?.status === 200) {
        toast.success(`Excel download link send successfully`);
      } else {
        toast.error(`Failed to send download link,Please try again`);
      }
    } catch (error) {
      console.error("Failed to send link:", error);
      toast.error(`Failed to send download link`);
    } finally {
      modalClose();
      setIsExcelLinkSend(false);
    }
  };
  const handleChangeStore = (e) => {
    dispatch(
      updateConfig((state) => {
        state.storeId = e?.customer_key;
      })
    );
  };

  const handleChangeOffer = (e) => {
    dispatch(
      updateConfig((state) => {
        state.offerId = e?.value;
      })
    );
  };

  let storeList = basicData?.data?.stores?.map((item) => {
    return {
      label: item?.name,
      value: item?._id,
      customer_key: item?.customer_key,
    };
  });
  let offerList = basicData?.data?.offers?.map((item) => {
    return {
      label: item?.name,
      value: item?._id,
    };
  });
  let storeListObj = storeList?.filter(
    (item) => item?.customer_key === cardOfferState?.storeId
  );
  let offerListObj = offerList?.filter(
    (item) => item?.value === cardOfferState?.offerId
  );

  return {
    date,
      storeListObj,
      offerListObj,
      isLoading,
      storeList,
      offerList,
      isFetching,
      showEditModal,
      isExcelLinkSend,
      paginationOptions,
      userFeedbackList,
      cardOfferState,
      handleUserFeedbackExcelDownload,
      updateUserFeedbackFields,
      handleEditColumnsClick,
      handleDateRangeChange,
      handleDateChange,
      handlePagination,
      handleClearClick,
      handlePageSize,
      handleSearch,
      sendExcelData,
      handleChangeStore,
      handleChangeOffer,
      handleSort,
      modalClose,
      refetch,
      getRow,
  };
};

export default useCardOffer;
